import RuleEditor from './RuleEditor';

export default RuleEditor;
